import React, {useState} from "react";

import EditableTextarea from "../inline-editable/textarea-inline-editable-new";
import {FieldEditableMode, FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";

// const debug = "FieldText_Editable"
const debug = false

export default function FieldText_Editable (props: FieldEditableProps){

    debug && console.log(debug, props)

    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onClick = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode !== FieldEditableMode.EDITING) setMode(FieldEditableMode.EDITING)
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        onChange(null)
    }

    const onChange = (newValue:any) => {
        props.onChange && props.onChange(newValue)

        setMode(FieldEditableMode.VIEW)
    }

    const value         = props.field.getViewValue(props.model)
    const displayValue  = props.field.getDisplayValue(value)

    const classes = Classes("ui5-field-editable", "ui5-field-view-value-multiline", "w-100-percent", {
        "ui5-txt-default"               : props.size === FieldViewSize.DEFAULT,
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
        "ui5-txt-less-important-small"  : props.size === FieldViewSize.SMALL,
        "size-small"                    : props.size === FieldViewSize.SMALL,
    })

    const viewValue = ()=>{
        const breakId = 'break_{0}'.f(gd.utils.guid());
        const viewValue = _.replace(displayValue, /(?:\r\n|\r|\n)/g, breakId).split(breakId);

        return (
            <div className="ui5-field-view-value-multiline p-t-6 p-b-8">
                {_.map(viewValue, (value, key) => (
                    <React.Fragment key={key}>
                        {value}
                        <br/>
                    </React.Fragment>
                ))}
            </div>
        )
    }

    const renderEditing = () => {
        return (
            <EditableTextarea
                className="ui5-txt-default ui5-field-form-editable w-100-percent p-t-6 p-b-8"
                textareaClassName="ui5-txt-default"
                value={value}
                focusOnMount={true}
                icon={null}
                onChange={onChange}
                placeholder={props.field.placeholder}/>
        )
    }

    const renderHovered = () => {

        const hoveredClasses = Classes(classes, "is-hovered")

        return (
            <div className={hoveredClasses}
                 onClick={onClick}
                onMouseLeave={onMouseLeave}
            >
                {viewValue()}

                <div className="buttons">
                    {!!displayValue && <div className="btn-reset" onClick={onDeleteClick}/>}
                </div>
            </div>
        )
    }

    const renderView = () => {

        return (
            <div className={classes}
                 onMouseEnter={onMouseEnter}
                 onClick={onClick}>

                {viewValue()}

            </div>
        )
    }

    switch (mode) {

        case FieldEditableMode.EDITING:
            return renderEditing()

        case FieldEditableMode.HOVERED:
            return renderHovered()

        case FieldEditableMode.VIEW:
        default:
            return renderView()
    }
}
